import { RootState } from '../../../reducers'
import { botFlowSelector } from './botFlowSelector'

export const botTestModeSelector = (state: RootState) => {
  return !!botFlowSelector(state)?.testMode
}
